import Vue from 'vue'
import { message, Spin } from 'ant-design-vue'
import './index.less'

Vue.use(Spin)
Vue.prototype.$message = message
